export default "__VITE_ASSET__b67927b5__"